const topics = [
  { id: 1, name: '吃瓜黑料网站', heat: '🔥 极热', count: '38.2万讨论', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { id: 2, name: '51黑料网站', heat: '🔥 极热', count: '35.6万讨论', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { id: 3, name: '91黑料网站', heat: '🔥 极热', count: '32.9万讨论', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { id: 4, name: '网红翻车实录', heat: '🔥 火热', count: '28.1万讨论', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { id: 5, name: '明星恋情曝光', heat: '🔥 火热', count: '25.7万讨论', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { id: 6, name: '综艺选秀黑幕', heat: '📈 上升', count: '19.3万讨论', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { id: 7, name: '娱乐圈资本局', heat: '📈 上升', count: '16.8万讨论', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { id: 8, name: '网红黑料网站推荐', heat: '📈 上升', count: '14.5万讨论', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { id: 9, name: '直播带货翻车', heat: '🆕 新晋', count: '11.2万讨论', color: 'bg-background-200 text-foreground-600 border-background-300' },
  { id: 10, name: '影视圈潜规则', heat: '🆕 新晋', count: '9.8万讨论', color: 'bg-background-200 text-foreground-600 border-background-300' },
  { id: 11, name: '最新黑料网站合集', heat: '🆕 新晋', count: '8.4万讨论', color: 'bg-background-200 text-foreground-600 border-background-300' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            全网最火的黑料话题都在这里，点击即达
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href={`#${topic.id}`}
              className={`inline-flex items-center gap-3 px-5 py-3 rounded-full border transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap ${topic.color}`}
            >
              <span className="text-sm md:text-base font-semibold">{topic.name}</span>
              <span className="text-xs opacity-70">{topic.heat}</span>
              <span className="text-xs opacity-60">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}